const mutations = {
  setProject(state, payload) {
    state.project = payload;
  },
  resetProject(state) {
    state.project = {
      id: 0,
      name: '',
      created_at: new Date(),
      updated_at: new Date(),
      description: '',
      responsible: {
        id: undefined,
        email: '',
        full_name: '',
        first_name: '',
        last_name: '',
        created_at: new Date(),
        updated_at: new Date(),
        labels: { data: []},
      },
      fnd: {
        id: undefined,
        name: '',
        code: '',
        description: '',
        created_at: new Date(),
        updated_at: new Date(),
      },
      attachments: undefined,
    };
  },
  setProjectID(state, payload) {
    state.project.id = Number(payload);
  },
  setProjects(state, payload) {
    state.projects = payload;
  },
  setControlPoints(state, payload) {
    state.controlPoints = payload;
  },
  setControlPointRequests(state, payload) {
    state.controlPointRequests = payload;
  },
  // ----------------------------
  // Control-point modal
  // ----------------------------
  setControlPoint(state, payload) {
    state.controlPoint = Object.assign({}, payload);
    state.controlPoint.fnd = Object.assign({}, payload.fnd);
    state.controlPoint.responsible = Object.assign({}, payload.responsible);
    state.controlPoint.executor = Object.assign({}, payload.executor);
  },
  switchControlPointModal(state) {
    state.isControlPointOpened = !state.isControlPointOpened;
  },
  setControlPointModal(state, mode) {
    if (mode) {
      state.isNotificationOpened = false;
      state.isControlPointRequestOpened = false;
    }
    state.isControlPointOpened = mode;
  },
  // ----------------------------
  // Control-point request modal
  // ----------------------------
  setControlPointRequest(state, payload) {
    state.controlPointRequest = Object.assign({}, payload);
  },
  switchControlPointRequestModal(state) {
    state.isControlPointRequestOpened = !state.isControlPointRequestOpened;
  },
  setControlPointRequestModal(state, mode) {
    if (mode) {
      state.isControlPointOpened = false;
      state.isNotificationOpened = false;
    }
    state.isControlPointRequestOpened = mode;
  },
  // ----------------------------
  // Notification modal
  // ----------------------------
  setNotification(state, payload) {
    state.notification = Object.assign({}, payload);
  },
  switchNotificationModal(state) {
    state.isNotificationOpened = !state.isNotificationOpened;
  },
  setNotificationModal(state, mode) {
    if (mode) {
      state.isControlPointOpened = false;
      state.isControlPointRequestOpened = false;
    }
    state.isNotificationOpened = mode;
  },
};

export default mutations;
